import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetBrivoConnectionRequest = {
  buildingId: number
}

// Note: the server only ever echoes clientId/clientSecret back — the other 5
// saved fields are write-only from the client's perspective.
export type BrivoConnection = {
  clientId?: string
  clientSecret?: string
}

export const getBrivoConnectionQueryKey = (data: GetBrivoConnectionRequest) => [
  'useGetBrivoConnection',
  data,
]

const getBrivoConnection = async (data: GetBrivoConnectionRequest) => {
  const response = await authAPI.get<BrivoConnection>(`/brivo/building/${data.buildingId}/client`)
  return response.data
}

export const useGetBrivoConnection = (data: GetBrivoConnectionRequest) =>
  useQuery({
    enabled: Boolean(data.buildingId),
    queryFn: () => getBrivoConnection(data),
    queryKey: getBrivoConnectionQueryKey(data),
  })
